import { useState, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { Spinner } from '@fluentui/react';
import PlaylistTable from '../Components/PlaylistTable';
import DeleteContentModal from "../Helpers/DeleteContentModal";
import { useBoolean } from "@fluentui/react-hooks";
import ErrorComponent from '../../../../Util/ErrorComponent';
import MessageBarComponent from '../../../../Util/MessageBarComponent';
import FluentSelect from '../../../../Forms/FluentSelect';

const PlaylistContent = ({ allContent }) => {
  const { setFieldValue, values } = useFormikContext();
  const [selectedContent, setSelectedContent] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);
  const [showAddContent, setShowAddContent] = useState(false);

  const playlist = values.seriesContent || [];
  const playlistId = values.conPlaylistID || 0;
  const isNew = playlistId === 0;
  const noEligibleData = !allContent || allContent?.length === 0;
  const loading = useMemo(() => {
      return noEligibleData  && !isNew;
  }, [noEligibleData, isNew]);

  const handleDeleteContent = (item = selectedContent) => {
    if (!item) return false;

    const updatedPlaylist = playlist.filter(x => x.contentId !== item.contentId);
    setFieldValue("seriesContent", updatedPlaylist);
    const count = updatedPlaylist.filter(x => x.contentId === item.contentId);
    if (count.length === 0) setShowSuccess(true);
    return count.length === 0;
  };

  const mapNewContent = (id) => {
    if (!id) return;

    const item = allContent.find(x => x.contentId === id.value);
    const mappedItem = item ? {
        contentId: item.contentId,
        contentTitle: item.contentTitle,
        contentSlug: item.contentSlug,
        contentType: item.contentType,
        contentCategory: item.contentCategory,
        adminPath: `/Contents/Add/${item.contentId}`, // TODO: Update after content is migrated
        orderNumber: null,
        playlistId: values.conPlaylistID,
        seriesTitle: values.name,
    } : null;

    setFieldValue("seriesContent", [...playlist, mappedItem]);
    setShowAddContent(false);
    setShowSuccess(true);
  };

  if (loading) return <Spinner className="absolute-center" label="Loading Playlist..." />;

  return (
      <>
          <MessageBarComponent
            message="Playlist content updated. Remember to save."
            showMessage={showSuccess}
            setShowMessage={setShowSuccess}
          />
          <ErrorComponent
              errorMessage={errorMsg}
              showError={showError}
              setShowError={setShowError}
          />
          {showAddContent && (
            <div className="max-800">
              <FluentSelect
                options={allContent && allContent.map(c => ({ value: c.contentId, label: `${c.contentId} - ${c.contentTitle} - ${c.contentType}` }))}
                onChange={mapNewContent}
                label='Eligible Content'
                component={FluentSelect}
              />
              <label className="preview-upload-help">Search for content by Title or CONID. Then select to add to your playlist.</label>
            </div>
          )}
          <PlaylistTable
              playlist={playlist.sort((a, b) => (b.contentId - a.contentId))}
              setSelectedContent={setSelectedContent}
              createOnClick={() => setShowAddContent(true)}
              deleteOnClick={(item) => {
                setSelectedContent(item);
                toggleDeleteModal();
              }}
              showAddContent={showAddContent}
              loading={loading}
          />
          <DeleteContentModal
              showModal={showDeleteModal}
              toggleShowModal={toggleDeleteModal}
              handleDelete={() => handleDeleteContent(selectedContent)}
              setErrorMsg={setErrorMsg}
              setShowError={setShowError}
              setShowSuccess={setShowSuccess}
              resourceName={selectedContent?.contentTitle}
              resourceType="playlist item"
              confirmationValue={selectedContent?.contentTitle}
              selectedItem={selectedContent}            
          />
      </>
  );
};

export default PlaylistContent;
